<template>
  <DialogPanel
    modal-name="api-error-dialog" 
    main-button-text="閉じる" 
    @main-button-click="() => { $refs.theApiErrorDialog.hide() }" 
    ref="theApiErrorDialog">
    <div>
      <div class="title">
        エラーが発生しました
      </div>
      <div>
        <div>{{ message }}</div>
        <div v-show="description">{{ description }}</div>
      </div>
    </div>
  </DialogPanel>
</template>

<script>
export default {
  name: "ApiErrorDialog",
  components: {
    DialogPanel: () => import('./DialogPanel.vue'),
  },
  data() {
    return {
      message: '',
      description: ''
    };
  },
  computed: {
    apiError() {
      return this.$store.getters['api/apiError'];
    },
  },
  watch: {
    apiError: {
      handler(theApiError) {
        if(!theApiError) {
          return
        }
        this.$emit('show', theApiError);

        const routeName = this.$router.currentRoute.name;
        if (routeName === null) {
          this.$router.push({ name: 'root' })
          return
        }
      },
      deep: true,
    },
  },
  created(){
    this.$on('show', this.show);
  },
  methods: {
    /** ダイアログ表示 */
    show({ httpStatus, apiResponseCode, description, noErrorDialog }) {
      if (noErrorDialog) {
        // ダイアログ表示しない
        return;
      }
      this.message = '';
      if (httpStatus && httpStatus !== 200) {
        this.message = "HTTPレスポンス: " + httpStatus;
      }
      if (apiResponseCode && apiResponseCode !== 200) {
        this.message = "API結果コード: " + apiResponseCode;
      }
      this.description = description;

      console.log(this.message);
      console.log(this.description);

      this.$refs.theApiErrorDialog.show() 
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
